import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { supabase, isSupabaseConfigured } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";

type Props = {
  children: ReactNode;
  role?: "buyer" | "seller";
};

export default function RequireAuth({ children, role }: Props) {
  const { user, loading } = useAuth();
  const location = useLocation();

  const { data: profile, isLoading } = useQuery({
    queryKey: ["profile", user?.id],
    queryFn: async () => {
      if (!user || !isSupabaseConfigured) return null;
      const { data } = await supabase.from("profiles").select("role").eq("id", user.id).maybeSingle();
      return data;
    },
    enabled: !!user && isSupabaseConfigured,
  });

  if (loading || isLoading) return null; // could add skeleton
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (role && profile?.role !== role) return <Navigate to="/" replace />;
  return <>{children}</>;
}